import {
    GET_USERSADMIN,
    GET_USERADMIN_LIST_TYPE_DOCUMENT,
    GET_USERADMIN_LIST_TYPE_ROL,
    GET_STATE_LOADING,
    GET_USER_ADMIN_ID,
    GET_USER_ADMIN_COMPANY_ID,
    GET_AFFILIATEDUSERS_LIST_GENDER,
    GET_STARASSIGNMENT_SEARCHAFFILIATES,
    GET_USERSTATUS

    
} from "@/views/users_admin/store/types/types.js";

const getters = {
    [GET_USERSADMIN]: state => state.userAdmin,
    [GET_USERADMIN_LIST_TYPE_DOCUMENT]: state => state.typeUserAdmin,
    [GET_USERADMIN_LIST_TYPE_ROL]: state => state.typeUserAdminRol,
    [GET_STATE_LOADING]: state => state.loadingUser,
    [GET_USER_ADMIN_ID]: state => state.userAdminidDetails,
    [GET_USER_ADMIN_COMPANY_ID]: state => state.userAdminidDetailsCompany,
    [GET_AFFILIATEDUSERS_LIST_GENDER]: state => state.genderAffiliated,
    [GET_STARASSIGNMENT_SEARCHAFFILIATES]: state => state.searchAffiliates,
    [GET_USERSTATUS]: state => state.userStatus,

};

export default getters;